import axios from 'axios';
import store from '@/store/store';
import { actions } from '@/models/store.actions';

export const settingsService = { configGet, get };

let model = {
  get baseUrl() {
    return store.getters[actions.SETT_GET_APIURLGET];
  },
  get curLocation() {
    return process.env.BASE_URL;
  }
};

function extract(r) {
  return r.data;
}

function configGet() {
  return axios.get(`${model.curLocation}static/config.json?tmp=${new Date().toLocaleString()}`).then(extract);
}

async function get() {
  return axios.get(`${model.baseUrl}settings`).then(extract);
}
